import * as React from "react";
import { SVGProps } from "react";
const SvgLogoGoogleCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-google-calendar_svg__a)">
      <path d="M4.263 4.263h9.474v9.474H4.263V4.263Z" fill="#fff" />
      <path d="M13.737 18 18 13.737h-4.263V18Z" fill="#EA4335" />
      <path d="M13.737 4.263H18v9.474h-4.263V4.263Z" fill="#FBBC04" />
      <path d="M4.263 13.737h9.474V18H4.263v-4.263Z" fill="#34A853" />
      <path
        d="M0 13.737v2.842a1.42 1.42 0 0 0 1.421 1.42h2.842v-4.262H0Z"
        fill="#188038"
      />
      <path
        d="M18 4.263V1.421A1.42 1.42 0 0 0 16.58 0h-2.843v4.263H18Z"
        fill="#1967D2"
      />
      <path
        d="M13.737 0H1.42A1.42 1.42 0 0 0 0 1.421v12.316h4.263V4.263h9.474V0Z"
        fill="#4285F4"
      />
      <path
        d="M6.208 11.613c-.353-.24-.6-.59-.735-1.05l.822-.338c.076.284.206.504.391.66.185.157.41.235.673.235.267 0 .5-.083.694-.246a.781.781 0 0 0 .29-.626.774.774 0 0 0-.305-.632c-.203-.163-.46-.246-.765-.246h-.476v-.813h.427c.263 0 .483-.07.663-.213a.702.702 0 0 0 .27-.582c0-.22-.08-.396-.242-.526a.943.943 0 0 0-.613-.197c-.242 0-.434.064-.576.194-.142.13-.248.294-.31.474l-.812-.339a1.83 1.83 0 0 1 .594-.81c.29-.234.66-.35 1.11-.35.332 0 .633.064.899.194.265.13.473.308.622.535.15.228.225.484.225.77 0 .289-.068.535-.208.737-.14.201-.313.355-.516.464v.05c.263.109.49.286.66.516.173.23.259.507.259.829 0 .322-.083.608-.247.862-.163.253-.39.45-.675.594a2.13 2.13 0 0 1-.97.218 2.05 2.05 0 0 1-1.15-.364Zm5.047-4.079-.903.651-.45-.684 1.62-1.168h.62v5.51h-.885V7.533h-.002Z"
        fill="#4285F4"
      />
    </g>
    <defs>
      <clipPath id="logo-google-calendar_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoGoogleCalendar;
